import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ScrollToTop } from './components/layout/scrollTop/scrollToTop'

import Main from './containers/main'
import MakeClaimMailReferral from './containers/makeClaimMailReferral'
import SignDocuments from './containers/signDocuments'

export default function AppRouter() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Main />}>
                    <Route path="/" element={<MakeClaimMailReferral />} />
                    <Route path="/sign/:token" element={<SignDocuments />} />
                </Route>
            </Routes>
        </Router>
    )
}
